import React, { useState, useEffect, useCallback } from "react";
import { Card, CardBody, Row, Col, Button, Alert } from "reactstrap";
import { Textbox, Checkbox, Textarea, Select as Select1 } from "react-inputs-validation";
import "../../../../styles/estilos.css";
import Page from "components/Page";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import DatePicker from "react-datepicker";
import { fetchConsultarIdentificacionAP } from "../../../../redux/actions/aCotizacion";
import { guardarFacturacionPymesFetch } from "../../redux/aRenovaciones";
import { ambienteAplicacion } from "../../../../constants/urls";
import Select from "react-select";
import makeAnimated from "react-select/lib/animated";

import ValoresRenovacion from "../../components/ValoresRenovacion";
import { expresionesRegulares, infoIds } from "../../../../constants";
import { estaEnListaNegra, LimpiarListaNegra } from "../../../../redux/actions/ACarritoProductos";
import moment from "moment";
import GestionPagadores from "./GestionPagadores";
import { preferenciasPagadorService } from "../../services/preferenciasPagadorService";

const validarCedulaEcuatoriana = (cedula) => {
  if (typeof cedula !== 'string') return false;
  if (cedula.length !== 10) return false;
  if (!/^\d+$/.test(cedula)) return false;

  const provincia = parseInt(cedula.substring(0, 2), 10);
  if (provincia < 1 || (provincia > 24 && provincia !== 30)) return false;

  const tercerDigito = parseInt(cedula.substring(2, 3), 10);
  if (tercerDigito >= 6) return false;

  const digitoVerificador = parseInt(cedula.substring(9, 10), 10);
  let suma = 0;
  const coeficientes = [2, 1, 2, 1, 2, 1, 2, 1, 2];

  for (let i = 0; i < 9; i++) {
    let valor = parseInt(cedula.substring(i, i + 1), 10) * coeficientes[i];
    if (valor > 9) valor -= 9;
    suma += valor;
  }

  const residuo = suma % 10;
  const calculo = residuo === 0 ? 0 : 10 - residuo;

  return calculo === digitoVerificador;
};

const DatosFacturacionPymes = (props) => {
  const CONFIG_DESHABILITAR_EDICION_CONTRATANTE = true;
  const CONFIG_HABILITAR_ACCIONES_PAGADOR = false;

  const {
    location,
    dataFacturacion,
    renovacionId: propsRenovacionId,
    limpiarDatosListaNegra,
    onChangeProvincia,
    consultarIdentificacion,
    datosIdentificacion,
    guardarFacturacion,
    respuestaFacturacion,
    catalogos,
    history,
    onLoadingExternoChange,
  } = props;

  const queryParams = new URLSearchParams(location.search);
  const idCarritoURL = queryParams.get("id");
  const renovacionIdURL = queryParams.get("renovacionId");

  const datosContratanteInicial = (dataFacturacion && dataFacturacion.datosFacturacion && dataFacturacion.datosFacturacion.carDatosContratante) ? dataFacturacion.datosFacturacion.carDatosContratante : null;

  const cambiarStringaFecha = (valor) => {
    if (typeof valor === "string" && valor.trim() !== "") {
      try {
        // Caso DD/MM/YYYY
        if (valor.includes("/")) {
          let fecha = valor.slice(0, 10).split("/", 3);
          if (fecha.length === 3) {
            const d = new Date(fecha[2], parseInt(fecha[1]) - 1, fecha[0]);
            if (!isNaN(d.getTime())) return d;
          }
        }
        // Caso YYYY-MM-DD (ISO devuelto por el servicio)
        if (valor.includes("-")) {
          let fecha = valor.slice(0, 10).split("-", 3);
          if (fecha.length === 3) {
            const d = new Date(fecha[0], parseInt(fecha[1]) - 1, fecha[2]);
            if (!isNaN(d.getTime())) return d;
          }
        }
        // Intento genérico con el constructor de Date
        const fallbackDate = new Date(valor);
        if (!isNaN(fallbackDate.getTime())) {
          return fallbackDate;
        }
      } catch (e) {
        console.error("Error parseando fecha:", valor, e);
      }
    }
    // Si nada funciona, devolvemos null en lugar del string original
    // para evitar el RangeError: Invalid time value en react-datepicker
    return null;
  };

  const cambiarFechaaString = (valor) => {
    if (valor && typeof valor.toISOString === "function") {
      return moment(valor).format("DD/MM/YYYY");
    }
    return valor;
  };

  // State variables
  const [validate, setValidate] = useState(false);
  const [valAlerta, setValAlerta] = useState(false);
  const [idCarrito] = useState(idCarritoURL);
  const [renovacionId] = useState(renovacionIdURL || propsRenovacionId || null);
  const [pathRegresar, setPathRegresar] = useState(undefined);
  const [mismosDatos, setMismosDatos] = useState(true);

  const [datosPagador, setDatosPagador] = useState({
    id: datosContratanteInicial ? datosContratanteInicial.mongoIdentificador || "" : "",
    identificacion: datosContratanteInicial ? datosContratanteInicial.cliIdentificacion || "" : "",
    codTipodocumento: datosContratanteInicial ? datosContratanteInicial.cliTipoDocumento || "" : "",
    cliNombres: datosContratanteInicial ? datosContratanteInicial.cliNombres || "" : "",
    cliApellidos: datosContratanteInicial ? datosContratanteInicial.cliApellidos || "" : "",
    correo: datosContratanteInicial ? datosContratanteInicial.cliEmail || "" : "",
    direccion: datosContratanteInicial ? datosContratanteInicial.cliDireccion || "" : "",
    celular: datosContratanteInicial ? datosContratanteInicial.cliCelular || "" : "",
    codEstadoCivil: datosContratanteInicial ? datosContratanteInicial.cliCodEstadoCivil || "" : "",
    codGenero: datosContratanteInicial ? datosContratanteInicial.cliCodGenero || "" : "",
    provincia: datosContratanteInicial ? datosContratanteInicial.provincia || "" : "",
    ciudad: datosContratanteInicial ? datosContratanteInicial.ciudad || "" : "",
    fechaNacimiento: datosContratanteInicial && datosContratanteInicial.cliFechaNacimiento ? cambiarStringaFecha(datosContratanteInicial.cliFechaNacimiento) : null,
    fechaEmisionPasaporte: datosContratanteInicial && datosContratanteInicial.cliFechaExpedicionPasaporte ? cambiarStringaFecha(datosContratanteInicial.cliFechaExpedicionPasaporte) : null,
    fechaCaducidadPasaporte: datosContratanteInicial && datosContratanteInicial.cliFechaVecimientoPasaporte ? cambiarStringaFecha(datosContratanteInicial.cliFechaVecimientoPasaporte) : null,
    fechaIngresoPais: datosContratanteInicial && datosContratanteInicial.cliFechaIngresoPais ? cambiarStringaFecha(datosContratanteInicial.cliFechaIngresoPais) : null,
  });

  const [valDatosPagador, setValDatosPagador] = useState({
    hasIdentificacionError: true,
    hasCodTipoDocError: true,
    hasNombreError: true,
    hasApellidoError: true,
    hasECivilError: true,
    hasGeneroError: true,
    hasCorreoError: true,
    hasDireccionError: true,
    hasCelularError: true,
    hasFechaNacimiento: false,
    hasFechaEmisionPasaporte: false,
    hasFechaCaducidadPasaporte: false,
    hasFechaIngresoPais: false,
    hasProvinciaError: false,
    hasCiudadError: false,
    esPasaporte: datosContratanteInicial ? (datosContratanteInicial.cliTipoDocumento === infoIds.codigoPasaporteStr) : false,
    esruc: datosContratanteInicial ? (datosContratanteInicial.cliTipoDocumento === infoIds.codigoRucStr) : false,
  });

  const [listaPagadores, setListaPagadores] = useState([]);
  const [totalParticipacion, setTotalParticipacion] = useState(0);
  const [personeriValue, setPersoneriValue] = useState("1");
  const [loadingPagadores, setLoadingPagadores] = useState(false);
  const [maxPagadores, setMaxPagadores] = useState(15);

  const [mismosDatosLoading, setMismosDatosLoading] = useState(true);
  const [mismosDatosSaving, setMismosDatosSaving] = useState(false);
  const [mismosDatosError, setMismosDatosError] = useState(null);

  const [validationError, setValidationError] = useState(null);
  const [validationErrorType, setValidationErrorType] = useState(null);

  const cargarPreferenciasMismosDatos = useCallback(async () => {
    const idPreferencias = idCarrito || renovacionId;
    if (!idPreferencias) {
      setMismosDatosLoading(false);
      return;
    }

    try {
      const data = await preferenciasPagadorService.obtenerPreferencia(idPreferencias);
      const mismosDatosResponse = (data && data.preferencias && data.preferencias.mismosDatos !== undefined) ? data.preferencias.mismosDatos : true;
      const serverMaxPagadores = (data && data.preferencias && data.preferencias.maxPagadores) ? data.preferencias.maxPagadores : 15;

      setMismosDatos(CONFIG_DESHABILITAR_EDICION_CONTRATANTE ? false : mismosDatosResponse);
      setMaxPagadores(serverMaxPagadores);
      setMismosDatosLoading(false);
    } catch (error) {
      console.error("Error cargando preferencia mismosDatos:", error);
      setMismosDatosLoading(false);
      setMismosDatosError(null);
    }
  }, [idCarrito, renovacionId]);

  useEffect(() => {
    limpiarDatosListaNegra();
    if (datosPagador.provincia && datosPagador.provincia !== "" && datosPagador.provincia.value) {
      onChangeProvincia(datosPagador.provincia.value);
    }

    if (dataFacturacion && dataFacturacion.urlRegresar !== undefined) {
      let cortarURl = dataFacturacion.urlRegresar.split("?")[0];
      setPathRegresar("/" + cortarURl);
    }

    cargarPreferenciasMismosDatos();
    // eslint-disable-next-line
  }, []);

  // Map raw provincia/ciudad values to Select objects once catalogs are loaded
  useEffect(() => {
    if (datosPagador.provincia && typeof datosPagador.provincia !== "object" && catalogos.provinciasSelect && catalogos.provinciasSelect.length > 0) {
      const foundProv = catalogos.provinciasSelect.find(p => String(p.value) === String(datosPagador.provincia));
      if (foundProv) {
        setDatosPagador(prev => ({ ...prev, provincia: foundProv }));
        onChangeProvincia(foundProv.value.toString());
      }
    }
  }, [catalogos.provinciasSelect, datosPagador.provincia, onChangeProvincia]);

  useEffect(() => {
    if (datosPagador.ciudad && typeof datosPagador.ciudad !== "object" && catalogos.ciudadesSelect && catalogos.ciudadesSelect.length > 0) {
      const foundCiu = catalogos.ciudadesSelect.find(c => String(c.value) === String(datosPagador.ciudad));
      if (foundCiu) {
        setDatosPagador(prev => ({ ...prev, ciudad: foundCiu }));
      }
    }
  }, [catalogos.ciudadesSelect, datosPagador.ciudad]);

  // Synchronize unique payer when edit actions are disabled
  useEffect(() => {
    if (!CONFIG_HABILITAR_ACCIONES_PAGADOR) {
      const dfData = (dataFacturacion && dataFacturacion.datosFacturacion) ? dataFacturacion.datosFacturacion : dataFacturacion;
      const carDatosPagador = (dfData && dfData.carDatosPagador) ? dfData.carDatosPagador : null;
      const sourceData = (carDatosPagador && carDatosPagador.cliIdentificacion) ? carDatosPagador : (dfData ? dfData.carDatosContratante : null);

      if (sourceData) {
        const singlePayer = {
          id: sourceData.mongoIdentificador || "",
          identificacion: sourceData.cliIdentificacion || "",
          codTipodocumento: sourceData.cliTipoDocumento || "",
          cliNombres: sourceData.cliNombres || "",
          cliApellidos: sourceData.cliApellidos || "",
          correo: sourceData.cliEmail || "",
          direccion: sourceData.cliDireccion || "",
          celular: sourceData.cliCelular || "",
          codEstadoCivil: sourceData.cliCodEstadoCivil || "",
          codGenero: sourceData.cliCodGenero || "",
          provincia: sourceData.provincia || "",
          ciudad: sourceData.ciudad || "",
          fechaNacimiento: sourceData.cliFechaNacimiento ? cambiarStringaFecha(sourceData.cliFechaNacimiento) : null,
          participacion: 100,
        };

        if (
          listaPagadores.length !== 1 ||
          listaPagadores[0].identificacion !== singlePayer.identificacion ||
          listaPagadores[0].cliNombres !== singlePayer.cliNombres ||
          listaPagadores[0].cliApellidos !== singlePayer.cliApellidos ||
          listaPagadores[0].correo !== singlePayer.correo ||
          listaPagadores[0].direccion !== singlePayer.direccion ||
          listaPagadores[0].celular !== singlePayer.celular ||
          listaPagadores[0].participacion !== 100
        ) {
          setListaPagadores([singlePayer]);
          setTotalParticipacion(100);
        }
      }
    }
  }, [dataFacturacion, listaPagadores]);

  useEffect(() => {
    const dfData = (dataFacturacion && dataFacturacion.datosFacturacion) ? dataFacturacion.datosFacturacion : dataFacturacion;
    const carDatosContratante = dfData ? dfData.carDatosContratante : null;

    const formEstaVacio = (!datosPagador.identificacion || datosPagador.identificacion === "") && (!datosPagador.codTipodocumento || datosPagador.codTipodocumento === "");
    
    if (carDatosContratante && formEstaVacio) {
      const provinciaToLoad = carDatosContratante.provincia || "";
      
      setDatosPagador({
        id: carDatosContratante.mongoIdentificador || "",
        identificacion: carDatosContratante.cliIdentificacion || "",
        codTipodocumento: carDatosContratante.cliTipoDocumento || "",
        cliNombres: carDatosContratante.cliNombres || "",
        cliApellidos: carDatosContratante.cliApellidos || "",
        correo: carDatosContratante.cliEmail || "",
        direccion: carDatosContratante.cliDireccion || "",
        celular: carDatosContratante.cliCelular || "",
        codEstadoCivil: carDatosContratante.cliCodEstadoCivil || "",
        codGenero: carDatosContratante.cliCodGenero || "",
        provincia: provinciaToLoad,
        ciudad: carDatosContratante.ciudad || "",
        fechaNacimiento: carDatosContratante.cliFechaNacimiento ? cambiarStringaFecha(carDatosContratante.cliFechaNacimiento) : null,
        fechaEmisionPasaporte: carDatosContratante.cliFechaExpedicionPasaporte ? cambiarStringaFecha(carDatosContratante.cliFechaExpedicionPasaporte) : null,
        fechaCaducidadPasaporte: carDatosContratante.cliFechaVecimientoPasaporte ? cambiarStringaFecha(carDatosContratante.cliFechaVecimientoPasaporte) : null,
        fechaIngresoPais: carDatosContratante.cliFechaIngresoPais ? cambiarStringaFecha(carDatosContratante.cliFechaIngresoPais) : null,
      });

      setValDatosPagador(prev => ({
        ...prev,
        esPasaporte: carDatosContratante.cliTipoDocumento === infoIds.codigoPasaporteStr,
        esruc: carDatosContratante.cliTipoDocumento === infoIds.codigoRucStr,
      }));

      if (provinciaToLoad && provinciaToLoad !== "") {
        onChangeProvincia(provinciaToLoad.value);
      }
    }
  }, [dataFacturacion, datosPagador.identificacion, datosPagador.codTipodocumento, onChangeProvincia]);

  const handleMismosDatosChange = async (newValue) => {
    const idPreferencias = idCarrito || renovacionId;
    const valorAnterior = mismosDatos;

    setMismosDatos(newValue);
    setMismosDatosSaving(true);
    setMismosDatosError(null);

    try {
      await preferenciasPagadorService.guardarPreferencia(idPreferencias, newValue);
      setMismosDatosSaving(false);
    } catch (error) {
      console.error("Error guardando preferencia mismosDatos:", error);
      setMismosDatos(valorAnterior);
      setMismosDatosSaving(false);
      setMismosDatosError("No se pudo guardar. Se restauró el valor anterior.");
    }
  };

  const onClickRegresar = (e) => {
    e.preventDefault();
    if (renovacionId && (!idCarrito || idCarrito === "null")) {
      history.push({
        pathname: "/renovacion",
        search: `?id=${renovacionId}`,
      });
      return;
    }

    let paramAdicional = (dataFacturacion && dataFacturacion.paramAdicional) ? dataFacturacion.paramAdicional : "";
    history.push({
      pathname: pathRegresar,
      search: `?id=${idCarrito}${paramAdicional}&resumen=true`,
    });
  };

  const consultaRucCedula = async (params) => {
    const { identificacion, tipo, tipodato } = params;
    let prov = "";
    let ciu = "";
    let valSelect = true;
    let valFecha = true;

    await consultarIdentificacion({
      empresa: "AIGMETROPOLITANA",
      identificador: identificacion,
      tipo: tipo,
    });

    let datos = {};
    if (datosIdentificacion && datosIdentificacion.IdentificacionAP && Object.keys(datosIdentificacion.IdentificacionAP).length > 0) {
      datos = datosIdentificacion.IdentificacionAP[0];
    }

    const {
      mongoIdentificador = "",
      nombre = "",
      nombres = "",
      apellidos = "",
      direccion = "",
      paiCodigoCore = "",
      provCodigoCore = "",
      provNombre = "",
      ciuCodigoCore = "",
      ciuNombre = "",
      correo = "",
      celular = "",
      generoCod = "",
      cliCodigoEstadoCivil = "",
      fechNacimiento = null,
    } = datos;

    if (fechNacimiento !== null) valFecha = false;

    if (provCodigoCore) {
      onChangeProvincia(provCodigoCore);
      prov = {
        value: `${provCodigoCore}`,
        label: `${provNombre}`,
        paiCodigoCore: `${paiCodigoCore}`,
      };
      ciu = {
        value: `${ciuCodigoCore}`,
        label: `${ciuNombre}`,
      };
      valSelect = false;
    }

    if (tipodato === "1") {
      setValidate(false);
      if (tipo === "ruc") {
        setDatosPagador(prev => ({
          ...prev,
          id: `${mongoIdentificador}`,
          cliNombres: `${nombre}`,
          direccion: `${direccion}`,
          fechaNacimiento: fechNacimiento ? cambiarStringaFecha(fechNacimiento) : null,
          celular: `${celular}`,
          correo: `${correo}`,
          provincia: prov,
          ciudad: ciu,
        }));
      } else if (tipo === "cedula") {
        setDatosPagador(prev => ({
          ...prev,
          id: `${mongoIdentificador}`,
          cliNombres: `${nombres}`,
          cliApellidos: `${apellidos}`,
          direccion: `${direccion}`,
          correo: `${correo}`,
          celular: `${celular}`,
          codGenero: `${generoCod}`,
          codEstadoCivil: `${cliCodigoEstadoCivil}`,
          fechaNacimiento: fechNacimiento ? cambiarStringaFecha(fechNacimiento) : null,
          provincia: prov,
          ciudad: ciu,
        }));
      }

      setValDatosPagador(prev => ({
        ...prev,
        hasProvinciaError: valSelect,
        hasCiudadError: valSelect,
        hasFechaNacimiento: valFecha,
      }));
    }
  };

  const modificarStateFechas = (dataAux) => {
    let newData = { ...dataAux };
    if (newData.fechaNacimiento) newData.fechaNacimiento = cambiarFechaaString(newData.fechaNacimiento);
    if (newData.fechaEmisionPasaporte) newData.fechaEmisionPasaporte = cambiarFechaaString(newData.fechaEmisionPasaporte);
    if (newData.fechaIngresoPais) newData.fechaIngresoPais = cambiarFechaaString(newData.fechaIngresoPais);
    if (newData.fechaCaducidadPasaporte) newData.fechaCaducidadPasaporte = cambiarFechaaString(newData.fechaCaducidadPasaporte);

    if (newData.codTipodocumento !== infoIds.codigoPasaporteStr) {
      delete newData['fechaCaducidadPasaporte'];
      delete newData['fechaEmisionPasaporte'];
      delete newData['fechaIngresoPais'];
    }
    return newData;
  };

  const enviarDatos = async (pagadores, contratante) => {
    if (onLoadingExternoChange) onLoadingExternoChange(true, "Guardando datos de facturación...");

    const contratanteClean = modificarStateFechas({ ...contratante });
    const pagadoresClean = pagadores.map(p => modificarStateFechas({ ...p }));

    const datosJSON = {
      empresa: "AIGMETROPOLITANA",
      plataforma: "WEB",
      datosContratante: contratanteClean,
      datosPagadorFacturacion: pagadoresClean[0],
      pagadores: pagadoresClean,
      totalParticipacion: totalParticipacion,
      idCarrito: idCarrito,
      idRenovacion: renovacionId,
      ambiente: ambienteAplicacion,
    };

    const currentResp = await guardarFacturacion(datosJSON);

    if (currentResp && currentResp.transaccion === true) {
      history.push({
        pathname: "/forma-pago-pymes",
        search: "?renovacionId=" + renovacionId,
      });
    } else {
      if (onLoadingExternoChange) onLoadingExternoChange(false);
      const errorMsg = (currentResp && currentResp.errorDescripcion) ? currentResp.errorDescripcion : "Ha ocurrido un error al procesar su petición. Por favor intente nuevamente.";
      setValidationError(errorMsg);
      setValidationErrorType("danger");
    }
  };

  const validateForm = async () => {
    setValidate(true);
    setValidationError(null);
    setValidationErrorType(null);

    // Synchronous Validation checks
    const dp = datosPagador;
    const isRuc = valDatosPagador.esruc;
    const isPasaporte = valDatosPagador.esPasaporte;

    const idValid = isRuc ? /^\d{13}$/.test(dp.identificacion || "") : (isPasaporte ? String(dp.identificacion || "").trim() !== "" : /^\d{10}$/.test(dp.identificacion || ""));
    const tipoDocValid = String(dp.codTipodocumento || "").trim() !== "";
    const nombresValid = String(dp.cliNombres || "").trim() !== "";
    const apellidosValid = isRuc ? true : String(dp.cliApellidos || "").trim() !== "";
    const correoValid = /^\S+@\S+\.\S+$/.test(dp.correo || "");
    const direccionValid = String(dp.direccion || "").trim() !== "";
    const celularValid = /^\d{10}$/.test(dp.celular || "");
    const provinciaValid = dp.provincia && dp.provincia !== "";
    const ciudadValid = dp.ciudad && dp.ciudad !== "";
    const fechaNacimientoValid = isPasaporte ? true : (dp.fechaNacimiento !== null && dp.fechaNacimiento !== "");

    // Validación de mayoría de edad (18 años) — solo para cédula y pasaporte, no para RUC
    let esMayorDeEdad = true;
    if (!isRuc && dp.fechaNacimiento) {
      const fechaNac = moment(dp.fechaNacimiento);
      const edad = moment().diff(fechaNac, 'years');
      esMayorDeEdad = edad >= 18;
    }

    const emisionPasaporteValid = !isPasaporte ? true : (dp.fechaEmisionPasaporte !== null && dp.fechaEmisionPasaporte !== "");
    const caducidadPasaporteValid = !isPasaporte ? true : (dp.fechaCaducidadPasaporte !== null && dp.fechaCaducidadPasaporte !== "");
    const ingresoPaisValid = !isPasaporte ? true : (dp.fechaIngresoPais !== null && dp.fechaIngresoPais !== "");

    const eCivilValid = isRuc ? true : String(dp.codEstadoCivil || "").trim() !== "";
    const generoValid = isRuc ? true : String(dp.codGenero || "").trim() !== "";

    const contValPag = (!idValid ? 1 : 0) + (!tipoDocValid ? 1 : 0) + (!nombresValid ? 1 : 0) + (!apellidosValid ? 1 : 0) + (!correoValid ? 1 : 0) + (!direccionValid ? 1 : 0) + (!celularValid ? 1 : 0) + (!provinciaValid ? 1 : 0) + (!ciudadValid ? 1 : 0) + (!fechaNacimientoValid ? 1 : 0) + (!emisionPasaporteValid ? 1 : 0) + (!caducidadPasaporteValid ? 1 : 0) + (!ingresoPaisValid ? 1 : 0) + (!eCivilValid ? 1 : 0) + (!generoValid ? 1 : 0);

    // Validación de mayoría de edad antes de validar campos vacíos
    /*if (!esMayorDeEdad) {
      setValDatosPagador(prev => ({ ...prev, hasFechaNacimiento: true }));
      setValidationError("El contratante debe ser mayor de 18 años.");
      setValidationErrorType("warning");
      window.scrollTo(0, 0);
      return;
    }*/

    if (!provinciaValid) setValDatosPagador(prev => ({ ...prev, hasProvinciaError: true }));
    if (!ciudadValid) setValDatosPagador(prev => ({ ...prev, hasCiudadError: true }));
    if (!fechaNacimientoValid) setValDatosPagador(prev => ({ ...prev, hasFechaNacimiento: true }));

    if (!correoValid || !celularValid) {
      setValidationError("Por favor ingrese un correo electrónico y un número de celular válidos (10 dígitos).");
      setValidationErrorType("warning");
      window.scrollTo(0, 0);
      return;
    }

    if (mismosDatos) {
      const payerFromContratante = {
        ...datosPagador,
        participacion: 100,
        codTipodocumento: datosPagador.codTipodocumento,
        identificacion: datosPagador.identificacion
      };
      enviarDatos([payerFromContratante], datosPagador);
    } else {
      if (listaPagadores.length === 0) {
        setValidationError("Debe agregar al menos un pagador.");
        setValidationErrorType("warning");
        return;
      }

      // Validar que ningún pagador tenga participaciones con decimales o no numéricas
      const pagadoresInvaliidos = listaPagadores.filter(p => {
        const part = parseFloat(p.participacion);
        return isNaN(part) || !Number.isInteger(part);
      });

      if (pagadoresInvaliidos.length > 0) {
        setValidationError("Uno o más pagadores tienen participaciones con decimales o inválidas. Por favor, edítelos para que sean números enteros.");
        setValidationErrorType("warning");
        return;
      }

      // Validar que ningún pagador tenga cédulas ecuatorianas inválidas
      const pagadoresCedulasInvalidas = listaPagadores.filter(p => {
        return p.codTipodocumento === infoIds.codigoCedulaStr && !validarCedulaEcuatoriana(p.identificacion || "");
      });

      if (pagadoresCedulasInvalidas.length > 0) {
        setValidationError("Uno o más pagadores tienen una cédula ecuatoriana inválida. Edítelos para corregirla.");
        setValidationErrorType("warning");
        return;
      }

      if (totalParticipacion !== 100) {
        setValidationError(`La participación total actual es ${totalParticipacion}%. Debe ser exactamente 100% para continuar. Ajuste la participación de los pagadores.`);
        setValidationErrorType("warning");
        return;
      }
      enviarDatos(listaPagadores, datosPagador);
    }
  };

  const handleLoadingChange = (loading) => {
    setLoadingPagadores(loading);
    if (onLoadingExternoChange) {
      onLoadingExternoChange(loading, loading ? "Procesando pagadores..." : "");
    }
  };

  const tipoDocumentosList = React.useMemo(() => [
    { id: "", name: "Seleccione..." },
    { id: infoIds.codigoCedulaStr, name: "Cédula" },
    { id: infoIds.codigoRucStr, name: "Ruc" },
    { id: infoIds.codigoPasaporteStr, name: "Pasaporte" },
  ], []);

  const listadoTipoDocumentos = React.useMemo(() => [
    { id: 1, name: "Natural" },
    { id: 2, name: "Jurídica" },
  ], []);

  return (
    <Page title="Datos Contratante - Facturación" breadcrumbs={[{ name: "Datos Contratante - Facturación", active: true }]}>
      <Row>
        <Col lg={8} md={12} sm={12} xs={12}>
          <div className="container-step">
            <div className="wrapper-step">
              <div className="arrow-steps clearfix-step">
                <div className="step"> {` 1. Cotización `} </div>
                <div className="step"> {` 2. Resumen `} </div>
                <div className="step current"> {` 3. Confirmación `} </div>
                <div className="step"> {` 4. Forma de Pago `} </div>
                <div className="step"> {` 5. Formulario de Vinculación `} </div>
                <div className="step"> {` 6. Emisión `} </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col lg={8} md={12} sm={12} xs={12} className="detalle-cotizacion-box mb-4 mb-lg-0">
          {valAlerta && (
            <Row>
              <Col lg={12} className="div-align-center">
                <Alert color="danger">
                  <p style={{ textAlign: "center" }}><i className="fa fa-exclamation-triangle fa-3x" aria-hidden="true"></i></p>
                  <p style={{ textAlign: "center" }}>No se pudo procesar su solicitud. Inténtalo nuevamente</p>
                </Alert>
              </Col>
            </Row>
          )}
          {CONFIG_DESHABILITAR_EDICION_CONTRATANTE ? (
            <Card className="flex-row">
              <CardBody>
                <Row>
                  <Col lg={12}><Button className="button-white" onClick={onClickRegresar}><i className="fa fa-chevron-circle-left" /> REGRESAR A RESUMEN</Button></Col>
                </Row>
                <h4 style={{ fontWeight: "bold" }}>Datos del contratante</h4>
                <p />
                
                <Row>
                  <Col lg={6} md={6} sm={6} xs={12}>
                    <h5 style={{ fontWeight: "bold" }}>Tipo de identificación</h5>
                  </Col>
                  <Col lg={6} md={6} sm={6} xs={12}>
                    <Textbox
                      classNameInput="input-type-label form-control"
                      value={
                        datosPagador.codTipodocumento === infoIds.codigoCedulaStr ? "Cédula" :
                        datosPagador.codTipodocumento === infoIds.codigoRucStr ? "Ruc" :
                        datosPagador.codTipodocumento === infoIds.codigoPasaporteStr ? "Pasaporte" :
                        datosPagador.codTipodocumento || ""
                      }
                    />
                  </Col>
                </Row>

          

                <Row>
                  <Col lg={6} md={6} sm={6} xs={12}>
                    <h5 style={{ fontWeight: "bold" }}>Número de Identificación</h5>
                  </Col>
                  <Col lg={6} md={6} sm={6} xs={12}>
                    <Textbox
                      classNameInput="input-type-label form-control"
                      value={datosPagador.identificacion}
                    />
                  </Col>
                </Row>

                {valDatosPagador.esPasaporte && (
                  <>
                    <Row>
                      <Col lg={6} md={6} sm={6} xs={12}>
                        <h5 style={{ fontWeight: "bold" }}>Fecha Expedición Pasaporte</h5>
                      </Col>
                      <Col lg={6} md={6} sm={6} xs={12}>
                        <Textbox
                          classNameInput="input-type-label form-control"
                          value={datosPagador.fechaEmisionPasaporte ? moment(datosPagador.fechaEmisionPasaporte).format("DD/MM/YYYY") : ""}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} md={6} sm={6} xs={12}>
                        <h5 style={{ fontWeight: "bold" }}>Fecha Vencimiento Pasaporte</h5>
                      </Col>
                      <Col lg={6} md={6} sm={6} xs={12}>
                        <Textbox
                          classNameInput="input-type-label form-control"
                          value={datosPagador.fechaCaducidadPasaporte ? moment(datosPagador.fechaCaducidadPasaporte).format("DD/MM/YYYY") : ""}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} md={6} sm={6} xs={12}>
                        <h5 style={{ fontWeight: "bold" }}>Fecha Ingreso al País</h5>
                      </Col>
                      <Col lg={6} md={6} sm={6} xs={12}>
                        <Textbox
                          classNameInput="input-type-label form-control"
                          value={datosPagador.fechaIngresoPais ? moment(datosPagador.fechaIngresoPais).format("DD/MM/YYYY") : ""}
                        />
                      </Col>
                    </Row>
                  </>
                )}

                <Row>
                  <Col lg={6} md={6} sm={6} xs={12}>
                    <h5 style={{ fontWeight: "bold" }}>{!valDatosPagador.esruc ? "Nombres" : "Razón Social"}</h5>
                  </Col>
                  <Col lg={6} md={6} sm={6} xs={12}>
                    <Textbox
                      classNameInput="input-type-label form-control"
                      value={datosPagador.cliNombres}
                    />
                  </Col>
                </Row>

                {!valDatosPagador.esruc && (
                  <>
                    <Row>
                      <Col lg={6} md={6} sm={6} xs={12}>
                        <h5 style={{ fontWeight: "bold" }}>Apellidos</h5>
                      </Col>
                      <Col lg={6} md={6} sm={6} xs={12}>
                        <Textbox
                          classNameInput="input-type-label form-control"
                          value={datosPagador.cliApellidos}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} md={6} sm={6} xs={12}>
                        <h5 style={{ fontWeight: "bold" }}>Estado Civil</h5>
                      </Col>
                      <Col lg={6} md={6} sm={6} xs={12}>
                        <Textbox
                          classNameInput="input-type-label form-control"
                          value={
                            catalogos.estadosCiviles && catalogos.estadosCiviles.find(e => String(e.id) === String(datosPagador.codEstadoCivil))
                              ? catalogos.estadosCiviles.find(e => String(e.id) === String(datosPagador.codEstadoCivil)).name
                              : datosPagador.codEstadoCivil || ""
                          }
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} md={6} sm={6} xs={12}>
                        <h5 style={{ fontWeight: "bold" }}>Género</h5>
                      </Col>
                      <Col lg={6} md={6} sm={6} xs={12}>
                        <Textbox
                          classNameInput="input-type-label form-control"
                          value={
                            catalogos.generos && catalogos.generos.find(g => String(g.id) === String(datosPagador.codGenero))
                              ? catalogos.generos.find(g => String(g.id) === String(datosPagador.codGenero)).name
                              : datosPagador.codGenero || ""
                          }
                        />
                      </Col>
                    </Row>
                  </>
                )}

                <Row>
                  <Col lg={6} md={6} sm={6} xs={12}>
                    <h5 style={{ fontWeight: "bold" }}>Provincia</h5>
                  </Col>
                  <Col lg={6} md={6} sm={6} xs={12}>
                    <Textbox
                      classNameInput="input-type-label form-control"
                      value={datosPagador.provincia ? (datosPagador.provincia.label || datosPagador.provincia) : ""}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col lg={6} md={6} sm={6} xs={12}>
                    <h5 style={{ fontWeight: "bold" }}>Ciudad</h5>
                  </Col>
                  <Col lg={6} md={6} sm={6} xs={12}>
                    <Textbox
                      classNameInput="input-type-label form-control"
                      value={datosPagador.ciudad ? (datosPagador.ciudad.label || datosPagador.ciudad) : ""}
                    />
                  </Col>
                </Row>

          

                <Row>
                  <Col lg={6} md={6} sm={6} xs={12}>
                    <h5 style={{ fontWeight: "bold" }}>Correo Electrónico (*)</h5>
                  </Col>
                  <Col lg={6} md={6} sm={6} xs={12}>
                    <Textbox
                      tabIndex="1"
                      type="text"
                      id="correo"
                      name="correo"
                      validate={validate}
                      classNameInput={"form-control"}
                      value={datosPagador.correo}
                      onChange={(correo) => setDatosPagador(prev => ({ ...prev, correo }))}
                      onBlur={() => { }}
                      validationCallback={(res) => {
                        setValDatosPagador(prev => ({ ...prev, hasCorreoError: res }));
                        setValidate(false);
                      }}
                      validationOption={{
                        name: "correo",
                        check: true,
                        reg: expresionesRegulares.email,
                        required: true,
                        msgOnError: "Por favor ingrese un correo electrónico válido"
                      }}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col lg={6} md={6} sm={6} xs={12}>
                    <h5 style={{ fontWeight: "bold" }}>Dirección</h5>
                  </Col>
                  <Col lg={6} md={6} sm={6} xs={12}>
                    <Textbox
                      classNameInput="input-type-label form-control"
                      value={datosPagador.direccion}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col lg={6} md={6} sm={6} xs={12}>
                    <h5 style={{ fontWeight: "bold" }}>Celular (*)</h5>
                  </Col>
                  <Col lg={6} md={6} sm={6} xs={12}>
                    <Textbox
                      tabIndex="2"
                      type="text"
                      id="celular"
                      name="celular"
                      validate={validate}
                      classNameInput={"form-control"}
                      value={datosPagador.celular}
                      onChange={(celular) => setDatosPagador(prev => ({ ...prev, celular }))}
                      onBlur={() => { }}
                      validationCallback={(res) => {
                        setValDatosPagador(prev => ({ ...prev, hasCellularError: res }));
                        setValidate(false);
                      }}
                      validationOption={{
                        name: "celular",
                        check: true,
                        required: true,
                        reg: /^\d{10}$/,
                        msgOnError: "Por favor ingrese un número de celular válido de 10 dígitos"
                      }}
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          ) : (
            <Card className="flex-row ">
              <CardBody>
                <Row>
                  <Col lg={12}><Button className="button-white" onClick={onClickRegresar}><i className="fa fa-chevron-circle-left" /> REGRESAR A RESUMEN</Button></Col>
                </Row>
                <Row>
                  <Col lg={8}><h4 style={{ fontWeight: "bold" }}>Datos del Contratante</h4></Col>
                  <Col lg={4}><div>(*) Campos Requeridos</div></Col>
                </Row>
                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}><h5>Tipo de identificación(*)</h5></Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    <Select1
                      tabIndex="6"
                      id={"selecTipoIdentificacion"}
                      name={"selecTipoIdentificacion"}
                      disabled={CONFIG_DESHABILITAR_EDICION_CONTRATANTE}
                      value={datosPagador.codTipodocumento}
                      validate={validate}
                      optionList={tipoDocumentosList}
                      onChange={(codTipodocumento) => {
                        setDatosPagador(prev => ({ ...prev, codTipodocumento }));
                        if (codTipodocumento === infoIds.codigoPasaporteStr) {
                          setValDatosPagador(prev => ({ ...prev, esruc: false, esPasaporte: true }));
                        } else if (codTipodocumento === infoIds.codigoRucStr) {
                          setValDatosPagador(prev => ({ ...prev, esruc: true, esPasaporte: false }));
                        } else {
                          setValDatosPagador(prev => ({ ...prev, esruc: false, esPasaporte: false }));
                        }
                      }}
                      onBlur={() => { }}
                      validationCallback={(res) => {
                        setValDatosPagador(prev => ({ ...prev, hasCodTipoDocError: res }));
                        setValidate(false);
                      }}
                      validationOption={{ name: "selecTipoIdentificacion", check: true, required: true, msgOnError: "Por favor seleccione el tipo de identificación" }}
                    />
                  </Col>
                </Row>
             
                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}><h5>Número de Identificación (*)</h5></Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    <Textbox
                      tabIndex="1"
                      type="text"
                      id="identificacion"
                      name="identificacion"
                      disabled={CONFIG_DESHABILITAR_EDICION_CONTRATANTE}
                      classNameInput={"form-control"}
                      value={datosPagador.identificacion}
                      validate={validate}
                      onChange={(identificacion) => {
                        setDatosPagador(prev => ({ ...prev, identificacion }));
                        if (valDatosPagador.esruc && identificacion.length === 13 && datosPagador.codTipodocumento === infoIds.codigoRucStr) {
                          consultaRucCedula({ identificacion: identificacion, tipo: "ruc", tipodato: "1" });
                        } else if (!valDatosPagador.esruc && identificacion.length === 10 && datosPagador.codTipodocumento === infoIds.codigoCedulaStr) {
                          consultaRucCedula({ identificacion: identificacion, tipo: "cedula", tipodato: "1" });
                        }
                      }}
                      onBlur={() => { }}
                      validationCallback={(res) => {
                        setValDatosPagador(prev => ({ ...prev, hasIdentificacionError: res }));
                        setValidate(false);
                      }}
                      validationOption={{ 
                        check: true, 
                        required: true, 
                        msgOnError: "Por favor ingrese el número de identificación",
                        customFunc: (value) => {
                          if (valDatosPagador.esruc) {
                            return /^\d{13}$/.test(value || "") ? true : "RUC debe tener 13 dígitos";
                          }
                          if (valDatosPagador.esPasaporte) {
                            return (value || "").trim() !== "" ? true : "Ingrese el pasaporte";
                          }
                          return validarCedulaEcuatoriana(value || "") ? true : "Cédula ecuatoriana inválida";
                        }
                      }}
                    />
                  </Col>
                </Row>
                {valDatosPagador.esPasaporte && (
                  <>
                    <Row>
                      <Col lg={4} md={4} sm={4} xs={12}>
                        <h5>Fecha Expedición Pasaporte (*)</h5>
                      </Col>
                      <Col lg={8} md={8} sm={8} xs={12}>
                        <DatePicker
                          dateFormat="dd/MM/yyyy"
                          selected={datosPagador.fechaEmisionPasaporte}
                          disabled={CONFIG_DESHABILITAR_EDICION_CONTRATANTE}
                          onChange={(date) => {
                            setDatosPagador(prev => ({ ...prev, fechaEmisionPasaporte: date }));
                            setValDatosPagador(prev => ({ ...prev, hasFechaEmisionPasaporte: !date }));
                          }}
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          className="form-control"
                          placeholderText="Seleccione una fecha"
                        />
                        {valDatosPagador.hasFechaEmisionPasaporte && (
                          <span style={{ display: "block", color: "#ff5a57", fontSize: "1rem", marginLeft: "5px" }}>Por favor ingrese una fecha</span>
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={4} md={4} sm={4} xs={12}>
                        <h5>Fecha Vencimiento Pasaporte (*)</h5>
                      </Col>
                      <Col lg={8} md={8} sm={8} xs={12}>
                        <DatePicker
                          dateFormat="dd/MM/yyyy"
                          selected={datosPagador.fechaCaducidadPasaporte}
                          disabled={CONFIG_DESHABILITAR_EDICION_CONTRATANTE}
                          onChange={(date) => {
                            setDatosPagador(prev => ({ ...prev, fechaCaducidadPasaporte: date }));
                            setValDatosPagador(prev => ({ ...prev, hasFechaCaducidadPasaporte: !date }));
                          }}
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          className="form-control"
                          placeholderText="Seleccione una fecha"
                        />
                        {valDatosPagador.hasFechaCaducidadPasaporte && (
                          <span style={{ display: "block", color: "#ff5a57", fontSize: "1rem", marginLeft: "5px" }}>Por favor ingrese una fecha</span>
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={4} md={4} sm={4} xs={12}>
                        <h5>Fecha Ingreso al País (*)</h5>
                      </Col>
                      <Col lg={8} md={8} sm={8} xs={12}>
                        <DatePicker
                          dateFormat="dd/MM/yyyy"
                          selected={datosPagador.fechaIngresoPais}
                          disabled={CONFIG_DESHABILITAR_EDICION_CONTRATANTE}
                          onChange={(date) => {
                            setDatosPagador(prev => ({ ...prev, fechaIngresoPais: date }));
                            setValDatosPagador(prev => ({ ...prev, hasFechaIngresoPais: !date }));
                          }}
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          className="form-control"
                          placeholderText="Seleccione una fecha"
                        />
                        {valDatosPagador.hasFechaIngresoPais && (
                          <span style={{ display: "block", color: "#ff5a57", fontSize: "1rem", marginLeft: "5px" }}>Por favor ingrese una fecha</span>
                        )}
                      </Col>
                    </Row>
                  </>
                )}
                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}><h5>{!valDatosPagador.esruc ? "Nombres (*)" : "Razón Social (*)"}</h5></Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    <Textbox
                      type="text"
                      disabled={CONFIG_DESHABILITAR_EDICION_CONTRATANTE}
                      value={datosPagador.cliNombres}
                      validate={validate}
                      classNameInput={"form-control"}
                      onChange={(cliNombres) => setDatosPagador(prev => ({ ...prev, cliNombres: cliNombres.toUpperCase() }))}
                      validationCallback={(res) => {
                        setValDatosPagador(prev => ({ ...prev, hasNombreError: res }));
                        setValidate(false);
                      }}
                      validationOption={{ required: true, msgOnError: "Por favor ingrese los nombres" }}
                    />
                  </Col>
                </Row>
                {!valDatosPagador.esruc && (
                  <>
                    <Row>
                      <Col lg={4} md={4} sm={4} xs={12}>
                        <h5>Apellidos (*)</h5>
                      </Col>
                      <Col lg={8} md={8} sm={8} xs={12}>
                        <Textbox
                          tabIndex="1"
                          type="text"
                          id="apellido"
                          name="apellido"
                          disabled={CONFIG_DESHABILITAR_EDICION_CONTRATANTE}
                          validate={validate}
                          classNameInput={"form-control"}
                          value={datosPagador.cliApellidos}
                          onChange={(cliApellidos) => setDatosPagador(prev => ({ ...prev, cliApellidos: cliApellidos.toUpperCase().trimStart() }))}
                          onBlur={() => { }}
                          validationCallback={(res) => {
                            setValDatosPagador(prev => ({ ...prev, hasApellidoError: res }));
                            setValidate(false);
                          }}
                          validationOption={{
                            required: true,
                            reg: /^[\u00e1\u00e9\u00ed\u00f3\u00fa\u00c1\u00c9\u00cd\u00d3\u00da\u00f1\u00d1A-Za-z _]*$/,
                            msgOnError: "Por favor ingrese los apellidos correctamente",
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={4} md={4} sm={4} xs={12}>
                        <h5>Estado Civil(*)</h5>
                      </Col>
                      <Col lg={8} md={8} sm={8} xs={12}>
                        <Select1
                          tabIndex="6"
                          id={"estadosCiviles"}
                          name={"estadosCiviles"}
                          disabled={CONFIG_DESHABILITAR_EDICION_CONTRATANTE}
                          value={datosPagador.codEstadoCivil}
                          optionList={catalogos.estadosCiviles}
                          validate={validate}
                          onChange={(codEstadoCivil) => setDatosPagador(prev => ({ ...prev, codEstadoCivil }))}
                          onBlur={() => { }}
                          validationCallback={(res) => {
                            setValDatosPagador(prev => ({ ...prev, hasECivilError: res }));
                            setValidate(false);
                          }}
                          validationOption={{ name: "estadosCiviles", check: true, required: true, msgOnError: "Por favor seleccione su estado civil" }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={4} md={4} sm={4} xs={12}>
                        <h5>Género(*)</h5>
                      </Col>
                      <Col lg={8} md={8} sm={8} xs={12}>
                        <Select1
                          tabIndex="6"
                          id={"generos"}
                          name={"generos"}
                          disabled={CONFIG_DESHABILITAR_EDICION_CONTRATANTE}
                          value={datosPagador.codGenero}
                          optionList={catalogos.generos}
                          validate={validate}
                          onChange={(codGenero) => setDatosPagador(prev => ({ ...prev, codGenero }))}
                          onBlur={() => { }}
                          validationCallback={(res) => {
                            setValDatosPagador(prev => ({ ...prev, hasGeneroError: res }));
                            setValidate(false);
                          }}
                          validationOption={{ name: "generos", check: true, required: true, msgOnError: "Por favor seleccione el género" }}
                        />
                      </Col>
                    </Row>
                  </>
                )}
                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Provincia(*)</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    <Select
                      value={datosPagador.provincia}
                      isDisabled={CONFIG_DESHABILITAR_EDICION_CONTRATANTE}
                      components={makeAnimated()}
                      onChange={(provincia) => {
                        setDatosPagador(prev => ({ ...prev, provincia, ciudad: "" }));
                        setValDatosPagador(prev => ({ ...prev, hasProvinciaError: !provincia }));
                        if (provincia && provincia.value) onChangeProvincia(provincia.value.toString());
                      }}
                      options={catalogos.provinciasSelect}
                      isSearchable={true}
                      placeholder={"Seleccione una provincia"}
                      isMulti={false}
                    />
                    {valDatosPagador.hasProvinciaError && (
                      <span style={{ color: "#ff5a57", fontSize: "1rem", marginLeft: "5px" }}>Por favor seleccione una provincia</span>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Ciudad(*)</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    <Select
                      value={datosPagador.ciudad}
                      isDisabled={CONFIG_DESHABILITAR_EDICION_CONTRATANTE}
                      components={makeAnimated()}
                      onChange={(ciudad) => {
                        setDatosPagador(prev => ({ ...prev, ciudad }));
                        setValDatosPagador(prev => ({ ...prev, hasCiudadError: !ciudad }));
                      }}
                      options={catalogos.ciudadesSelect}
                      isSearchable={true}
                      placeholder={"Seleccione una ciudad"}
                      isMulti={false}
                    />
                    {valDatosPagador.hasCiudadError && (
                      <span style={{ color: "#ff5a57", fontSize: "1rem", marginLeft: "5px" }}>Por favor seleccione una ciudad</span>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>{!valDatosPagador.esruc ? "Fecha nacimiento(*)" : "Fecha de Constitución (*)"}</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    <DatePicker
                      dateFormat="dd/MM/yyyy"
                      selected={datosPagador.fechaNacimiento}
                      disabled={CONFIG_DESHABILITAR_EDICION_CONTRATANTE}
                      onChange={(date) => {
                        setDatosPagador(prev => ({ ...prev, fechaNacimiento: date }));
                        if (!valDatosPagador.esruc && date) {
                          const edad = moment().diff(moment(date), 'years');
                          setValDatosPagador(prev => ({ ...prev, hasFechaNacimiento: edad < 18 }));
                        } else {
                          setValDatosPagador(prev => ({ ...prev, hasFechaNacimiento: !date }));
                        }
                      }}
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      className="form-control"
                      placeholderText="Seleccione una fecha"
                      maxDate={!valDatosPagador.esruc ? moment().subtract(18, 'years').toDate() : new Date()}
                    />
                    {valDatosPagador.hasFechaNacimiento && (
                      <span style={{ display: "block", color: "#ff5a57", fontSize: "1rem", marginLeft: "5px" }}>
                        {!valDatosPagador.esruc ? "El contratante debe ser mayor de 18 años" : "Por favor ingrese una fecha"}
                      </span>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Correo Electrónico (*)</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    <Textbox
                      type="text"
                      id="correo"
                      name="correo"
                      disabled={CONFIG_DESHABILITAR_EDICION_CONTRATANTE}
                      validate={validate}
                      classNameInput={"form-control"}
                      value={datosPagador.correo}
                      onChange={(correo) => setDatosPagador(prev => ({ ...prev, correo }))}
                      onBlur={() => { }}
                      validationCallback={(res) => {
                        setValDatosPagador(prev => ({ ...prev, hasCorreoError: res }));
                        setValidate(false);
                      }}
                      validationOption={{ name: "correo", check: true, reg: expresionesRegulares.email, required: true, msgOnError: "Por favor ingrese un correo electronico válido" }}
                    />
                  </Col>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Dirección (*)</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    <Textarea
                      type="input"
                      value={datosPagador.direccion}
                      disabled={CONFIG_DESHABILITAR_EDICION_CONTRATANTE}
                      name="direccion"
                      id="direccion"
                      classNameInput={"form-control"}
                      validate={validate}
                      onChange={(direccion) => setDatosPagador(prev => ({ ...prev, direccion: direccion.toUpperCase().trimStart() }))}
                      onBlur={() => { }}
                      validationCallback={(res) => {
                        setValDatosPagador(prev => ({ ...prev, hasDireccionError: res }));
                        setValidate(false);
                      }}
                      validationOption={{
                        name: "direccion",
                        check: true,
                        required: false,
                        customFunc: () => {
                          const dir = datosPagador.direccion;
                          if (dir === "" || dir === null || dir === undefined) {
                            return "Por favor ingrese una dirección";
                          }
                          return true;
                        },
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Celular (*)</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    <Textbox
                      tabIndex="1"
                      type="text"
                      id="celular"
                      name="celular"
                      disabled={CONFIG_DESHABILITAR_EDICION_CONTRATANTE}
                      validate={validate}
                      classNameInput={"form-control"}
                      value={datosPagador.celular}
                      onChange={(celular) => setDatosPagador(prev => ({ ...prev, celular }))}
                      onBlur={() => { }}
                      validationCallback={(res) => {
                        setValDatosPagador(prev => ({ ...prev, hasCellularError: res }));
                        setValidate(false);
                      }}
                      validationOption={{ name: "celular", check: true, required: true, reg: /^\d{10}$/, msgOnError: "Por favor ingrese un número de celular valido" }}
                    />
                  </Col>
                </Row>
                {/* Checkbox Mismos Datos */}
                <Row style={CONFIG_DESHABILITAR_EDICION_CONTRATANTE ? { display: "none" } : {}}>
                  <Col md={6} xs={12}>
                    {mismosDatosLoading ? (
                      <div className="font-italic text-muted mt-2"><i className="fa fa-spinner fa-spin mr-2"></i> Cargando preferencias...</div>
                    ) : (
                      <>
                        <Checkbox
                          id={"mismosDatos"}
                          name={"mismosDatos"}
                          value={mismosDatos}
                          checked={mismosDatos}
                          disabled={mismosDatosSaving || CONFIG_DESHABILITAR_EDICION_CONTRATANTE}
                          labelHtml={
                            <div style={{ paddingTop: "0.5em" }}>
                              <h5>
                                Utilizar los mismos datos para pago y facturación
                                {mismosDatosSaving && <small className="ml-2 text-muted">(Guardando...)</small>}
                              </h5>
                            </div>
                          }
                          onChange={handleMismosDatosChange}
                          validationOption={{ required: true, msgOnError: "Este campo es requerido" }}
                        />
                        {mismosDatosError && (
                          <Alert color="danger" className="mt-2">{mismosDatosError}</Alert>
                        )}
                        {mismosDatos && (
                          <Alert color="info">
                            Al seleccionar esta opción, el contratante asumirá el 100% de la participación de pago.
                          </Alert>
                        )}
                      </>
                    )}
                  </Col>
                </Row>
              </CardBody>
            </Card>
          )}

          {/* GESTION DE PAGADORES */}
          {!mismosDatos && (
            CONFIG_HABILITAR_ACCIONES_PAGADOR ? (
              <GestionPagadores
                renovacionId={renovacionId}
                listaPagadores={listaPagadores}
                totalParticipacion={totalParticipacion}
                loadingPagadores={loadingPagadores}
                onPagadoresChange={(lista, total) => {
                  setListaPagadores(lista);
                  setTotalParticipacion(total);
                }}
                onLoadingChange={handleLoadingChange}
                maxPagadores={maxPagadores}
                consultarIdentificacion={consultarIdentificacion}
                datosIdentificacion={datosIdentificacion}
                cambiarStringaFecha={cambiarStringaFecha}
                habilitarAcciones={CONFIG_HABILITAR_ACCIONES_PAGADOR}
              />
            ) : (
              <Card className="flex-row mt-3">
                <CardBody>
                  <h4 style={{ fontWeight: "bold" }}>Datos del pagador</h4>
                  <p />

                  <Row>
                    <Col lg={6} md={6} sm={6} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>Tipo de identificación</h5>
                    </Col>
                    <Col lg={6} md={6} sm={6} xs={12}>
                      <Textbox
                        classNameInput="input-type-label form-control"
                        value={
                          listaPagadores[0] ? (
                            listaPagadores[0].codTipodocumento === infoIds.codigoCedulaStr ? "Cédula" :
                            listaPagadores[0].codTipodocumento === infoIds.codigoRucStr ? "Ruc" :
                            listaPagadores[0].codTipodocumento === infoIds.codigoPasaporteStr ? "Pasaporte" :
                            listaPagadores[0].codTipodocumento || ""
                          ) : ""
                        }
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={6} md={6} sm={6} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>Número de Identificación</h5>
                    </Col>
                    <Col lg={6} md={6} sm={6} xs={12}>
                      <Textbox
                        classNameInput="input-type-label form-control"
                        value={listaPagadores[0] ? listaPagadores[0].identificacion : ""}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={6} md={6} sm={6} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>{(listaPagadores[0] && listaPagadores[0].codTipodocumento === infoIds.codigoRucStr) ? "Razón Social" : "Nombres"}</h5>
                    </Col>
                    <Col lg={6} md={6} sm={6} xs={12}>
                      <Textbox
                        classNameInput="input-type-label form-control"
                        value={listaPagadores[0] ? listaPagadores[0].cliNombres : ""}
                      />
                    </Col>
                  </Row>

                  {(listaPagadores[0] && listaPagadores[0].codTipodocumento !== infoIds.codigoRucStr) && (
                    <Row>
                      <Col lg={6} md={6} sm={6} xs={12}>
                        <h5 style={{ fontWeight: "bold" }}>Apellidos</h5>
                      </Col>
                      <Col lg={6} md={6} sm={6} xs={12}>
                        <Textbox
                          classNameInput="input-type-label form-control"
                          value={listaPagadores[0] ? listaPagadores[0].cliApellidos : ""}
                        />
                      </Col>
                    </Row>
                  )}

                  <Row>
                    <Col lg={6} md={6} sm={6} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>Correo Electrónico</h5>
                    </Col>
                    <Col lg={6} md={6} sm={6} xs={12}>
                      <Textbox
                        classNameInput="input-type-label form-control"
                        value={listaPagadores[0] ? listaPagadores[0].correo : ""}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={6} md={6} sm={6} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>Dirección</h5>
                    </Col>
                    <Col lg={6} md={6} sm={6} xs={12}>
                      <Textbox
                        classNameInput="input-type-label form-control"
                        value={listaPagadores[0] ? listaPagadores[0].direccion : ""}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={6} md={6} sm={6} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>Celular</h5>
                    </Col>
                    <Col lg={6} md={6} sm={6} xs={12}>
                      <Textbox
                        classNameInput="input-type-label form-control"
                        value={listaPagadores[0] ? listaPagadores[0].celular : ""}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={6} md={6} sm={6} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>Participación</h5>
                    </Col>
                    <Col lg={6} md={6} sm={6} xs={12}>
                      <Textbox
                        classNameInput="input-type-label form-control"
                        value="100%"
                      />
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            )
          )}
        </Col>

        <Col lg={4} md={12} sm={12} xs={12} className="detalle-impuestos-box mt-4 mt-lg-0">
          <div className="sticky-top" style={{ top: '20px', zIndex: 10 }}>
            <ValoresRenovacion
              validarFormulario={validateForm}
              valoresTotales={(dataFacturacion && dataFacturacion.datosFacturacion && dataFacturacion.datosFacturacion.carValoresTotales) ? dataFacturacion.datosFacturacion.carValoresTotales : null}
              validationError={validationError}
              validationErrorType={validationErrorType}
              dataRenovacion={(dataFacturacion && dataFacturacion.datosFacturacion) ? dataFacturacion.datosFacturacion : null}
              paso={"datos-facturacion"}
            />
          </div>
        </Col>
      </Row>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  catalogos: state.catalogosCotizacion,
  dataUsuario: state.datosUsuarios.dataUsuario,
  datosIdentificacion: state.datosIdentificacionAP,
  respuestaFacturacion: state.dataGuardarFacturacionPymes,
  datosListaNegra: state.datosListaNegra,
  dataFacturacion: state.dataFacturacion
});

const mapDispatchToProps = (dispatch) => {
  return {
    consultarIdentificacion: (datos) => dispatch(fetchConsultarIdentificacionAP(datos)),
    guardarFacturacion: (data) => dispatch(guardarFacturacionPymesFetch(data)),
    checkInListaNegra: (identificacion) => dispatch(estaEnListaNegra(identificacion)),
    limpiarDatosListaNegra: () => dispatch(LimpiarListaNegra()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DatosFacturacionPymes)
);
